import { render } from "./UpdatePaymentMethodModal.vue?vue&type=template&id=bba75df0"
import script from "./UpdatePaymentMethodModal.vue?vue&type=script&lang=js"
export * from "./UpdatePaymentMethodModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__